// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ArchiveBannerMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ArchiveBannerMutation = { __typename?: 'Mutation', archiveBanner: { __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null } };

export type BannerFieldsFragment = { __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null };

export type BannerContentFieldsFragment = { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> };

export type CallToActionFieldsFragment = { __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null };

export const CallToActionFieldsFragmentDoc = gql`
    fragment CallToActionFields on CallToAction {
  url_default
  url_ios
  url_android
  label
  image {
    url
  }
}
    `;
export const BannerContentFieldsFragmentDoc = gql`
    fragment BannerContentFields on BannerContent {
  title_lines
  body
  color_mode
  image {
    url
  }
  ctas {
    ...CallToActionFields
  }
}
    ${CallToActionFieldsFragmentDoc}`;
export const BannerFieldsFragmentDoc = gql`
    fragment BannerFields on Banner {
  id
  type
  content_default {
    ...BannerContentFields
  }
  content_mobile {
    ...BannerContentFields
  }
}
    ${BannerContentFieldsFragmentDoc}`;
export const ArchiveBannerDocument = gql`
    mutation archiveBanner($id: ID!) {
  archiveBanner(id: $id) {
    ...BannerFields
  }
}
    ${BannerFieldsFragmentDoc}`;
export type ArchiveBannerMutationFn = Apollo.MutationFunction<ArchiveBannerMutation, ArchiveBannerMutationVariables>;

/**
 * __useArchiveBannerMutation__
 *
 * To run a mutation, you first call `useArchiveBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveBannerMutation, { data, loading, error }] = useArchiveBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveBannerMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveBannerMutation, ArchiveBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveBannerMutation, ArchiveBannerMutationVariables>(ArchiveBannerDocument, options);
      }
export type ArchiveBannerMutationHookResult = ReturnType<typeof useArchiveBannerMutation>;
export type ArchiveBannerMutationResult = Apollo.MutationResult<ArchiveBannerMutation>;
export type ArchiveBannerMutationOptions = Apollo.BaseMutationOptions<ArchiveBannerMutation, ArchiveBannerMutationVariables>;